import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DeviationPicker.css';

const REASONS = [
  { id: 1, icon: '🚫', labelKey: 'reasonSkipped' },
  { id: 2, icon: '🧴', labelKey: 'reasonNoSupplies' },
  { id: 3, icon: '🚪', labelKey: 'reasonAccessBlocked' },
  { id: 4, icon: '🔧', labelKey: 'reasonEquipmentMissing' },
  { id: 5, icon: '⏱️', labelKey: 'reasonTimeReduced' },
  { id: 6, icon: '👥', labelKey: 'reasonInterrupted' },
];

/**
 * Bottom sheet overlay to pick a deviation reason (PRD: execution_account_prd).
 */
export default function DeviationPicker({
  itemId,
  itemType,
  itemName,
  onSelect,
  onCancel,
}) {
  const { t } = useTranslation('execution');

  const handleSelect = (reason) => {
    onSelect({
      itemId,
      itemType: itemType || 'step',
      itemName: itemName || '',
      reasonId: reason.id,
      reasonLabel: t(reason.labelKey, reason.labelKey),
    });
  };

  return (
    <div className="deviation-picker-backdrop" onClick={onCancel} role="presentation">
      <div
        className="deviation-picker-sheet"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="deviation-picker-title"
      >
        <div className="deviation-picker-handle" />
        <h3 id="deviation-picker-title" className="deviation-picker-label">
          {t('reportProblem', 'Raportează problemă')}
        </h3>
        <p className="deviation-picker-item-name">{itemName}</p>
        <div className="deviation-picker-grid">
          {REASONS.map((r) => (
            <button
              key={r.id}
              type="button"
              className="deviation-picker-reason"
              onClick={() => handleSelect(r)}
            >
              <span className="deviation-picker-reason-icon">{r.icon}</span>
              <span className="deviation-picker-reason-label">
                {t(r.labelKey, r.labelKey)}
              </span>
            </button>
          ))}
        </div>
        <button type="button" className="btn btn-secondary deviation-picker-cancel" onClick={onCancel}>
          {t('cancel', 'Anulează')}
        </button>
      </div>
    </div>
  );
}
